import React, { FC } from 'react'
import { List, ListItem } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { ITeamMember } from 'apps/fleet-planner/types'
import { TeamMemberName, TeamMemberNameSkeleton } from './TeamMemberName'

const useTeamMembersListStyles = makeStyles(theme => ({
  list: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  item: {
    padding: theme.spacing(1.5),
    height: theme.spacing(9),
  },
}))

interface ITeamMembersListProps {
  /**
   * Should show the loading state?
   * @default false
   */
  isLoading?: boolean
  /**
   * Team members that will be listed
   */
  teamMembers: ITeamMember[]
  /**
   * Callback to be called when a team member is clicked
   */
  onTeamMemberClick: (teamMember: ITeamMember) => void
}

export const TeamMembersList: FC<ITeamMembersListProps> = ({
  isLoading = false,
  teamMembers = [],
  onTeamMemberClick,
}) => {
  const classes = useTeamMembersListStyles()

  const createListItemClickHandler = (teamMember: ITeamMember) => () => {
    onTeamMemberClick(teamMember)
  }

  if (isLoading) {
    return (
      <List className={classes.list}>
        {Array.from({ length: 10 }, (_, index) => (
          <ListItem key={index.toString()} className={classes.item} divider>
            <TeamMemberNameSkeleton />
          </ListItem>
        ))}
      </List>
    )
  }

  return (
    <List className={classes.list}>
      {teamMembers.map(teamMember => (
        <ListItem
          data-test='team-member-list-item'
          key={teamMember?.id}
          className={classes.item}
          onClick={createListItemClickHandler(teamMember)}
          divider>
          <TeamMemberName teamMember={teamMember} />
        </ListItem>
      ))}
    </List>
  )
}
